import { render, staticRenderFns } from "./Register-doenca.vue?vue&type=template&id=f28b9ad4&"
import script from "./Register-doenca.vue?vue&type=script&lang=js&"
export * from "./Register-doenca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports